"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickOutside = exports.useMask = exports.useGenerateId = exports.usePrevious = void 0;
const react_1 = __importDefault(require("react"));
const react_hook_mask_1 = require("react-hook-mask");
const lodash_1 = require("lodash");
const usePrevious = (initialValue, value) => {
    const ref = react_1.default.useRef(initialValue);
    react_1.default.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
};
exports.usePrevious = usePrevious;
const useGenerateId = (id, label) => {
    return react_1.default.useMemo(() => id || (0, lodash_1.uniqueId)(label), []);
};
exports.useGenerateId = useGenerateId;
const useMask = (mask, value, ref, onChange) => {
    const maskGenerator = (0, react_hook_mask_1.createDefaultMaskGenerator)(mask);
    const { value: maskValue, onChange: onMaskChange, ref: maskRef, } = (0, react_hook_mask_1.useWebMask)({
        value,
        maskGenerator,
        onChange,
        keepMask: true,
        ref,
    });
    return { maskValue, maskRef, onMaskChange };
};
exports.useMask = useMask;
/**
 * Use this hook when a dropdown needs to close itself when clicking outside
 *
 * @param onClickOutside - Callback method to run when condition is fulfiled
 * @returns dropRef: React.RefObject<HTMLInputElement>
 */
const useClickOutside = (show, onClickOutside) => {
    const dropRef = react_1.default.useRef(null);
    const handleUserKeyPress = react_1.default.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event) => {
        var _a;
        if (show && dropRef.current && !((_a = dropRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            onClickOutside === null || onClickOutside === void 0 ? void 0 : onClickOutside();
        }
    }, [show]);
    const cbRef = react_1.default.useRef(handleUserKeyPress);
    react_1.default.useEffect(() => {
        cbRef.current = handleUserKeyPress;
    });
    react_1.default.useEffect(() => {
        const cb = (e) => cbRef.current(e);
        window.addEventListener('mousedown', cb);
        return () => {
            window.removeEventListener('mousedown', cb);
        };
    }, []);
    return dropRef;
};
exports.useClickOutside = useClickOutside;
//# sourceMappingURL=hooks.js.map